import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Popupinfo = ({ message, type }) => {
  return (
    <Snackbar
      open={true}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      // key={'top center'}
    >
      <MuiAlert
        elevation={6}
        severity={type}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </MuiAlert>
    </Snackbar>
  );
};

export default Popupinfo;
